import { Subscription } from 'rxjs';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DropdownList } from '@src/core/domain/business-models';
import { ProfileAccessProvider } from '@src/data/repository/perfilamento/profile.repository';
import { AuthService } from '@src/shared/services/authV3/auth.service';
import { UsuarioToken } from '@src/shared/services/authV3/session-return-jwt.model';
import { ModalStateService } from '@src/shared/services/authV3/modal-state.service';

@Component({
    selector: 'default-company-list',
    templateUrl: './default-company-list.component.html',
    styleUrls: ['./default-company-list.component.scss'],
})
export class DefaultCompanyListComponent implements OnInit {

    public optionsCompany: DropdownList;
    public selected: any;
    public selectedCpfCnpj: any;
    public companyGreaterThanOne = false;
    public loading;
    public showModalDefaultCompany = false;
    public companyData: Array<any>;
    public askCompanyDefault = false;
    public noAgreed: boolean = false;
    public showPopover: boolean = false;
    @ViewChild('content', { static: true }) content: HTMLElement;

    public selectedCompany: Array<any>;
    public index = null;
    public isResponsive!: boolean;
    public showTerm = false;
    public varSubscriptTerm: Subscription;
    public idTermo: string;
    public closeModalTerm: boolean = false;
    public isAdesao: boolean = false;
    public showOverdraftLimitModal: boolean = false;
    public shouldShowModal: boolean = false;
    public flagShowCheckbox: boolean = false;
    @Input() readonly: boolean = false;

    constructor(
        private accessProvider: ProfileAccessProvider,
        private authServiceDecript: AuthService,
        public modalStateService: ModalStateService
    ) {
        this.accessProvider.getAccessUser();
        this.optionsCompany = [];
        this.loading = false;
    }

    ngOnInit(): void {
        this.isResponsive = window.innerWidth <= 1081;
        if (this.modalStateService.showPopover()) {
            this.modalStateService.setShouldEvaluateRule(false)
            this.conditionOpenModal();
        }
        this.conditionShowMenu();
    }

    async conditionOpenModal() {
        const showPopover = await JSON.parse(sessionStorage.getItem('showAskCompanyDefaultTwo'));
        const token = await sessionStorage.getItem('sessionToken');
        if (token) {
            const decodedData: UsuarioToken | null = await this.authServiceDecript.decodeJwt(token);
            if (decodedData && !showPopover && !decodedData.perguntarClientePadrao && decodedData.clientes.length > 1) {
                sessionStorage.setItem(
                    'defalutCompanyId',
                    decodedData.idClientePadrao.toString()
                );
                this.modalStateService.setAllowLoad(true);
                this.modalStateService.openModal(decodedData.clientes);
            } else {
                console.log('Condition modal false');
            }
        } else {
            console.log('Token de sessão não encontrado');
        }
    }
    async conditionShowMenu() {
        const token = await sessionStorage.getItem('sessionToken');
        if (token) {
            const decodedData: UsuarioToken | null = await this.authServiceDecript.decodeJwt(token);
            if (decodedData.clientes.length > 1) {
                if (!sessionStorage.getItem('defalutCompanyId')) {
                    sessionStorage.setItem('defalutCompanyId', decodedData.idClientePadrao.toString());
                }
                this.flagShowCheckbox = decodedData.perguntarClientePadrao;
                this.modalStateService.setShowEmpresaPadrao(true);
            } else {
                console.log('Condition modal false');
            }
        } else {
            console.log('Token de sessão não encontrado');
        }
    }
}
